import "./intro.css";

//import { FaAward } from "react-icons/fa";
import React from "react";
//import { VscFolderLibrary } from "react-icons/vsc";
import img from "../../assets/Me.jpg";

// import ME from '../../assets/Rasif Tagizade image.jpg';

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={img} alt="Anshima Sharma" />
          </div>
        </div>
        <div className="about__content">
          {/* <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1.5 year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div> */}
          <p>
            Hi, I am Anshima Sharma, a Front-end Development enthusiast, pursuing a
            Master's degree in Information Technology at the International
            Institute of Professional Studies DAVV, Indore. I am passionate and
            have problem-solving skills. Currently, I am learning JAVA language
            and code daily to improve my coding skills. Beyond coding, I am an
            NCC cadet of 1 M.P AIR WING NCC Indore. I got the opportunity to
            attend the National Camp (AIVSC CAMP 2023 in Banglore) of AIR NCC. I
            got four sorties(flying) on this beautiful journey. Excited to
            explore new technologies and broaden my knowledge.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
